<birdz-modal>
  <div modal-title>{{ 'KPI_SETTINGS_TITLE' | transloco }}</div>
  <div modal-body class="body">
    <mat-slide-toggle [(ngModel)]="showRawKpis">
      {{ 'SHOW_RAW_KPIS' | transloco }}
    </mat-slide-toggle>
    <p class="description">{{ 'RAW_KPI_DEFINITION' | transloco }}</p>
  </div>
  <ng-container modal-buttons>
    <button matButton (click)="cancel()">{{ 'CANCEL' | transloco }}</button>
    <button matButton="filled" (click)="save()">{{ 'SAVE' | transloco }}</button>
  </ng-container>
</birdz-modal>
